// extracted by mini-css-extract-plugin
export default {"removeIcon":"FileDropper_removeIcon__TQ42S","cropper":"FileDropper_cropper__9zHvA","cropArea":"FileDropper_cropArea__+8KAv"};